import type { IconSvgObject } from './types';

const BlockedIcon: IconSvgObject = [
  ["path", { d: "M21 5C18.8786 3.17002 15.6351 2 12 2C8.36494 2 5.12137 3.17002 3 5V11C3 19 12 22 12 22C12 22 21 19 21 11L21 5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.52514 13.4749C10.1585 14.1082 11.0335 14.5 12 14.5C13.933 14.5 15.5 12.9329 15.5 11C15.5 10.0335 15.1083 9.1585 14.4749 8.52512M9.52514 13.4749C8.89175 12.8415 8.5 11.9665 8.5 11C8.5 9.067 10.067 7.5 12 7.5C12.9665 7.5 13.8415 7.89175 14.4749 8.52512M9.52514 13.4749L14.4749 8.52512", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BlockedIcon;
